/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as SuggestionDefault } from './suggestion-default.story';
export { default as SuggestionSizes } from './suggestion-sizes.story';
export { default as SuggestionIcon } from './suggestion-icon.story';
export { default as SuggestionPrimary } from './suggestion-primary.story';

import { removeLicenseHeader } from '../../../_common/export-stories-utils';
import SuggestionDefaultSrcRaw from './suggestion-default.story?raw';
import SuggestionIconSrcRaw from './suggestion-icon.story?raw';
import SuggestionPrimarySrcRaw from './suggestion-primary.story?raw';
import SuggestionSizesSrcRaw from './suggestion-sizes.story?raw';

export const SuggestionDefaultSrc = removeLicenseHeader(
  SuggestionDefaultSrcRaw,
);
export const SuggestionSizesSrc = removeLicenseHeader(SuggestionSizesSrcRaw);
export const SuggestionIconSrc = removeLicenseHeader(SuggestionIconSrcRaw);
export const SuggestionPrimarySrc = removeLicenseHeader(
  SuggestionPrimarySrcRaw,
);
